import React, { useRef } from 'react';
import { UserSuspendedHeader } from './components/UserSuspendedHeader';
import { UserSuspendedBody } from './components/UserSuspendedBody';
import { useDisableScrollInModal } from './../../hooks/useDisableScrollInModal';
import { useUserSuspended } from './hooks/useUserSuspended';
import { useRedirectPlayerUserSuspended } from './hooks/useRedirectPlayerUserSuspended';
import { usePreventUserRemoveModal } from './hooks/usePreventUserRemoveModal';
import { getIsUserRegister } from './utils/getIsUserRegister';
import { getUserInfo } from './utils/getUserInfo';
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics';
import './style.scss';

const UserSuspendedModal = ({ tracking }) => {
  const isEmailRegister = getIsUserRegister();
  const isUserGetInfo = getUserInfo();
  const { isUserSuspended, isUserLoggedIn } = useUserSuspended(isEmailRegister, isUserGetInfo);

  useDisableScrollInModal(isUserSuspended);

  useRedirectPlayerUserSuspended(isUserSuspended, tracking);

  usePreventUserRemoveModal(isUserSuspended);

  useGoogleAnalytics(isUserSuspended);

  const emailRegisterIsNotSuspended = isEmailRegister && isUserLoggedIn === 0 && !isUserSuspended;
  const emailNotRegister = isUserLoggedIn === 0 && !isEmailRegister;
  if ( emailNotRegister || !isUserSuspended || emailRegisterIsNotSuspended) return null;

  return (
    <section id="user-suspended-modal" className="user-suspended-modal">
      <UserSuspendedHeader />
      <UserSuspendedBody />
    </section>
  );
};

export default UserSuspendedModal;
